// MapComponent.js
import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix default marker icon issues with Leaflet in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Component to handle dynamic zoom and centering
const MapViewUpdater = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center, 6); // Adjust zoom level as needed
    }
  }, [center, map]);

  return null;
};

const MapComponent = ({ data }) => {
  const coordinate = data?.currentLocation
    ? JSON.parse(data?.currentLocation)
    : [48.8566, 2.3522];

  return (
    <MapContainer
      center={coordinate}
      zoom={5}
      style={{ height: "400px", width: "100%" }}
    >
      {/* Update map view dynamically */}
      <MapViewUpdater center={coordinate} />

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      {/* Render a single marker */}
      <Marker position={coordinate}>
        <Popup>
          <b>Current Location</b>
          <br />
          Coordinates: {coordinate[0]}, {coordinate[1]}
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;
